import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Worklist } from './dashboard-work-list-filter.interface';

@Component({
  selector: 'app-voice-ai-dashboard-work-list-filter',
  templateUrl: './dashboard-work-list-filter.component.html',
  styleUrls: ['./dashboard-work-list-filter.component.scss'],
})
export class DashboardWorkListFilterComponent {
  @Input() worklists: Worklist[] = [];
  @Input() selectedWorklist: string = '';
  @Input() selectedAssignedTo: string = '';
  @Input() agentName: string = '';
  @Input() workListCounts: Record<string, number> = {};
  @Output() worklistSelected = new EventEmitter<string>();
  @Output() assignedToSelected = new EventEmitter<string>();

  get workListHasAnyCount(): boolean {
    return Object.keys(this.workListCounts).length > 0;
  }

  onWorklistClick(worklist: Worklist): void {
    if (worklist.id === 'assignedToMe') {
      this.assignedToSelected.emit(this.agentName);
    } else {
      this.worklistSelected.emit(worklist.id);
    }
  }

  isSelected(worklist: Worklist): boolean {
    return worklist.id === 'assignedToMe' ? this.selectedAssignedTo === this.agentName : this.selectedWorklist === worklist.id;
  }
}
